import { Table } from '@tanstack/react-table';
import { useState } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Popover } from '../../../../../design-system/popover/popover';
import { SortingVariant, TableSortingContent } from './table-sorting-content';
import { getSortingVariantContent } from './utils/get-sorting-variant-content';
import { onSortingOptionSelect } from './utils/on-sorting-option-select';

type TableSortingProps<TData> = {
  table: Table<TData>;
};

export const TableSorting = <TData,>({ table }: TableSortingProps<TData>) => {
  const [selectedSorting, setSelectedSorting] = useState<SortingVariant | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const { icon: Icon, label } = getSortingVariantContent(selectedSorting);

  const sortingOptionSelectHandler = onSortingOptionSelect(table);

  const onSelectSortingOption = (sorting: SortingVariant) => {
    sortingOptionSelectHandler(sorting);
    setSelectedSorting(sorting);
    setIsOpen(false);
  };

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      triggerElement={
        selectedSorting ? (
          <Button variant="secondary" iconLeft={<Icon />} className="bg-white">
            <span className="text-xs leading-6 font-normal tracking-tight text-muted-foreground">Sort by:</span> {label}
          </Button>
        ) : (
          <Button variant="secondary" iconLeft={<Icon />} className="bg-white">
            Sort
          </Button>
        )
      }
      content={<TableSortingContent onSelectSortingOption={onSelectSortingOption} />}
      align="end"
      className="min-w-max"
    />
  );
};
